import { FileWorkflowInstanceDto } from '../config/fileConfig'

/**
 * The sequence number is shown iff it distinguishes anything: above 1, or multiple instances of
 * the same workflow. Matches the server-side rule in TaskMapper (HAM-4121).
 */
export const workflowInstanceLabel = (name: string, sequenceNumber: number, siblingCount: number): string =>
    siblingCount > 1 || sequenceNumber > 1 ? `${name} (${sequenceNumber})` : name

/** Sorted, comma-joined labels of a file's workflow instances, e.g. "Aanvraag (1), Aanvraag (2), Bezwaar". */
export const workflowInstancesText = (instances: FileWorkflowInstanceDto[], getName: (workflowId: string) => string): string =>
    (instances || [])
        .map(instance =>
            workflowInstanceLabel(
                getName(instance.workflowId),
                instance.sequenceNumber,
                instances.filter(sibling => sibling.workflowId === instance.workflowId).length,
            ),
        )
        .sort()
        .join(', ')
